function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.4116 15.2505C14.4106 15.2505 14.4098 15.2505 14.4091 15.2504L14.3979 15.2487L14.3802 15.247C9.29061 14.735 5.26571 10.7096 4.7544 5.62013L4.75441 5.62013L4.75407 5.61687C4.7319 5.40556 4.80111 5.19484 4.94426 5.03782L4.94505 5.03696C5.11093 4.85442 5.34628 4.75054 5.59294 4.75098V4.75098H5.59428L7.54323 4.75098L7.5441 4.75098C7.92796 4.75053 8.26902 4.99621 8.3902 5.36065L8.39077 5.36237L9.026 7.25743C9.13313 7.57738 9.04911 7.93034 8.80935 8.16767L8.80666 8.17035L8.50174 8.47526L8.07391 8.90308L8.40155 9.41173C8.96745 10.2903 9.71704 11.036 10.5989 11.5972L11.107 11.9205L11.5324 11.4942L11.8307 11.1952C11.8309 11.1951 11.831 11.195 11.8311 11.1948C12.0704 10.9562 12.4239 10.8728 12.7447 10.9791C12.745 10.9792 12.7452 10.9793 12.7455 10.9794L14.6392 11.6142L14.641 11.6148C15.0048 11.7357 15.2503 12.0757 15.2506 12.4587V14.4069H15.2505L15.2507 14.4189C15.2579 14.868 14.9023 15.2386 14.4542 15.251L14.43 15.2509L14.4116 15.2505Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/numbers.e1a40c5a.svg";
export { SvgComponent as ReactComponent };